module.exports = __webpack_public_path__ + "df182bb043de4772afe2bf2ff718dc3b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-7.png
// module id = 2234
// module chunks = 0